"use client";

import { BoDollar, BoShieldCheck } from "solar-icon-react/bo";
import { AppContainer } from "@/components";
import { cn } from "@/lib";

// ─── Feature data ────────────────────────────────────────────────────────────
const ElectricityIcon = ({ size }: { size: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path fill="currentColor" d="M7 2v11h3v9l7-12h-4l4-8z" />
    </svg>
  );
};
const features = [
  {
    icon: <ElectricityIcon size="100%" />,
    title: "پاسخ آنی",
    description: "کمتر از ۳۰ ثانیه — بدون صف انتظار",
    iconClass: "bg-blue-200/40 text-blue-500",
  },
  {
    icon: <BoShieldCheck className="size-full" />,
    title: "امن و رسمی",
    description: "اتصال مستقیم به منابع دولتی",
    iconClass: "bg-green-200/40 text-green-500",
  },
  {
    icon: <BoDollar className="size-full" />,
    title: "ارزان‌ترین قیمت",
    description: "تنها ۲ هزارتومان برای استعلام و پرداخت قبوض",
    iconClass: "bg-yellow-200/40 text-yellow-500",
  },
];

export default function FeaturesSection() {
  return (
    <section className="w-full bg-gray-100/40 px-4 py-10">
      <AppContainer className="flex h-fit flex-col justify-center gap-8 lg:flex-row">
        {features.map((item, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center gap-4 lg:gap-6"
          >
            <div
              className={cn("h-[70px] w-[70px] rounded-lg p-4", item.iconClass)}
            >
              <span>{item.icon}</span>
            </div>
            <span className="text-lg font-bold lg:text-xl xl:text-2xl">
              {item.title}
            </span>
            <p className="text-base lg:text-lg">{item.description}</p>
          </div>
        ))}
      </AppContainer>
    </section>
  );
}
